import * as React from 'react'
import { IPostComponentProps } from "./IPostComponentProps"
import { IPostComponentState } from "./IPostComponentState"
import heart from 'src/assets/images/heart.png'
import 'src/assets/css/main.css'
import 'src/assets/css/reset.css'
import 'src/assets/css/fonts.css'

import { Link, withRouter } from 'react-router-dom'
import Palette from 'react-palette'
import { Placeholder } from 'semantic-ui-react'
import ContentLoader, { Facebook } from 'react-content-loader'
import Backend from "../../api/Backend";

export class PostComponent extends React.Component<IPostComponentProps, IPostComponentState> {



	constructor(props: IPostComponentProps) {
		super(props)

		this.state = {
			hover: false,
			isMounted: false,
			loading: true,
			downUrl : ''
		}
	}

	componentDidMount () {
		this.setState({ isMounted: true })


		Backend.storage().ref('thumb_gifs/'+this.props.id+'.gif').getDownloadURL().then(url => {
			this.setState({
				downUrl: url
			} , ()=>{console.log(url)})

		})
	}

	componentWillUnmount () {
		this.setState({isMounted: false})
	}

	onMouseEnterHandler () {
		if (this.state.isMounted) {
			this.setState({ hover: true })
		}
	}

	onMouseLeaveHandler () {
		if (this.state.isMounted) {
			this.setState({ hover: false })
		}
	}

	public render() {
		const {
			history,
			URL,
			id,
			half,
			favorites,
			title
		} = this.props

		const {
			hover , isMounted
		} = this.state

		return (
			<>
				{
					this.state.loading

					?	<div
							className={half ? 'halfitem' : 'onethirditem'}
							style={{
								margin: 1,
								//padding: 5,
								borderStyle: 'solid',
								borderWidth: hover ? '6px' : '3px',
								borderColor: 'white',

								transition: `all .2s ease-in-out`,
								transform: hover ? `scale(1.1)` : `scale(1)`,

								zIndex: hover ? 99 : 1,
								cursor: 'pointer'
							}}
						>
							<ContentLoader style={{height: '300px'}}>
								<rect x='0' y='0' rx='0' ry='0' width='100%' height='300px' />
							</ContentLoader>
						</div>

					:	null
				}

				<Palette image={URL} >
					{
						palette => {
							if (this.state.loading)
								this.setState({ loading: false })

							return (
								<div
									onClick={() => {
										history.push('/gif/' + id)
									}}
									className={half ? "halfitem " : "onethirditem "}
									onMouseEnter={this.onMouseEnterHandler.bind(this)}
									onMouseLeave={this.onMouseLeaveHandler.bind(this)}
									key={`${id}`}
									style={{
										height: 300,
										margin: 1,
										padding: 5,

										transition: `all .2s ease-in-out`,
										transform: hover ? `scale(1.1)` : `scale(1)`,

										zIndex: hover ? 99 : 1,
										cursor: 'pointer',
										borderStyle: 'solid',
										borderWidth: hover ? '6px' : '3px',
										borderColor: 'white',

										background: hover
													? `linear-gradient(180deg,rgba(1, 0, 0, 0),${palette.darkVibrant || '#000000BF'}),
														url(${this.state.downUrl}) 0% 0% / cover no-repeat`

													: `url(${this.state.downUrl}) 0% 0% / cover no-repeat`,

										backgroundRepeat: hover ? 'no-repeat' : 'no-repeat',
										backgroundSize: hover ? 'cover' : 'cover'
									}}
								>
									<div
										style={{
											position: "relative",
											top: 5,
											left: 2,
											width: 30,
											height: 20,
											display: "flex",
											flexDirection: "row",
											alignItems: "center",
											color: 'white'
										}}
									>
										<img
											src={heart}
											style={{
												width: 15,
												height: 15,
												marginRight: '5px'
											}}
											alt=""
										/>
										<p>{favorites}</p>
									</div>
									<p
										style={{
											position: "absolute",
											width: '90%',
											//top: 220,
											bottom: 9,
											left: 20,
											fontSize: "90%",
											color: "white",
											fontFamily: "Gotham_Bold",
											textShadow: '2px 2px rgba(10, 10, 10, 0.73)'
										}}
									>
										{title}
									</p>
								</div>
							)
						}
					}
				</Palette>
			</>
		)
	}
}

export default withRouter(PostComponent)



// WEBPACK FOOTER //
// ./src/components/PostComponent/PostComponent.tsx